import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

interface Constraint {
  types?: string[];
  size?: number;
}

export function IsFile(config?: Constraint, options?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    return registerDecorator({
      name: 'isFile',
      target: object.constructor,
      propertyName,
      constraints: [config],
      options,
      validator: {
        validate(value: any, { constraints }: ValidationArguments) {
          if (value instanceof File) {
            const { types, size } = (constraints[0] ?? {}) as Constraint;
            return !((types && !types.includes(value.type)) || (typeof size === 'number' && value.size > size));
          }
          return false;
        },
      },
    });
  };
}
